'use strict';


export default function($parse) {
	'ngInject';

	return {
		require: '^brgSlideGroup',
		link: postLink,
		scope: {
			overwrite: '@',
			default: '<',
		},
	};

	function postLink(scope, element, attrs, group) {
		element.addClass('brg-slide');
		group.addSlide(attrs.name, element, !!scope.overwrite);
		if (scope.default) {
			group.select(attrs.name);
		}
		scope.$on('$destroy', function() {
			group.removeSlide(attrs.name);
		});
	}
}
